import React, { useEffect } from 'react';
import './App.css';
const firebase = require('firebase');

const firebaseConfig = {
  apiKey: 'AIzaSyDEhGpbwwRnh3wQfgEHkaS8lVBeQE--KcM',
  authDomain: 'playfora-production.firebaseapp.com',
  projectId: 'playfora-production',
  storageBucket: 'playfora-production.appspot.com',
  messagingSenderId: '898227834578',
  appId: '1:898227834578:web:cef1a089374d444626e70b',
  measurementId: 'G-PXJFY45WCY',
};
firebase.initializeApp(firebaseConfig);
const firebaseui = require('firebaseui');
const messaging = firebase.messaging();

const callBacks = {
  signInSuccessWithAuthResult: (authResult, redirectURL) => {
    console.log(authResult);
    firebase
      .auth()
      .currentUser.getIdToken(/* forceRefresh */ true)
      .then(function (idToken) {
        // Send token to your backend via HTTPS
        // ...
        console.log('idToken: ', idToken);
        return true;
      })
      .catch(function (error) {
        // Handle error
        return false;
      });
    //console.log(authResult.currentUser);
  },
};

function App() {
  useEffect(() => {
    var ui = new firebaseui.auth.AuthUI(firebase.auth());

    ui.start('#firebaseui-auth-container', {
      signInSuccessUrl: '/success',
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          signInMethod:
            firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
        },
        firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      ],
      callbacks: callBacks,
      // Other config options...
    });

    // Get registration token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.
    messaging
      .getToken({
        vapidKey:
          'BL5ndYGyUWGxRZ-n-oghbTRIux9qtOD5XdxqF466vz1BNqIuv87RLWy47sqjq8ZNnROFB8PeLxjWs1jDV3G8H8g',
      })
      .then((currentToken) => {
        if (currentToken) {
          // Send the token to your server and update the UI if necessary
          // ...
          console.log('currentToken', currentToken);
        } else {
          // Show permission request UI
          console.log(
            'No registration token available. Request permission to generate one.'
          );
          // ...
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        // ...
      });

    messaging.onMessage((payload) => {
      console.log('Message received. ', payload);
      navigator.serviceWorker
        .getRegistration('/firebase-cloud-messaging-push-scope')
        .then((registration) => {
          const notificationTitle = payload.notification.title;
          const notificationOptions = {
            body: payload.notification.body,
            icon: payload.notification.image,
          };

          registration.showNotification(notificationTitle, notificationOptions);
        });
      // Update the UI to include the received message.
    });

    return () => {
      console.log('cleanup');
    };
  }, []);

  return (
    <React.Fragment>
      <div className="App" id="firebaseui-auth-container"></div>
    </React.Fragment>
  );
}

export default App;
